<template>
  <div :id="recaptchaId" data-size="invisible"></div>
</template>

<script>
import v4 from "uuid/v4";
export default {
  name: "ReCaptcha",
  props: {
    badge: {
      type: String,
      default: "bottomleft"
    },
    submit: {
      type: Function,
      required: true
    },
    executeSwitch: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      recaptchaKey: "6Le-pKIUAAAAAHbqlNrc3ZOYf2ilCoAnLvLZ0SGY",
      recaptchaId: `invisible-recaptcha-${v4()}`,
      widgetId: ""
    };
  },
  mounted() {
    if (typeof grecaptcha === "undefined") {
      const script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/api.js";
      script.setAttribute("async", "");
      script.setAttribute("defer", "");
      script.onload = this.callRender;
      document.head.appendChild(script);
    } else {
      this.callRender();
    }
  },
  methods: {
    render: function() {
      this.widgetId = grecaptcha.render(this.recaptchaId, {
        sitekey: this.recaptchaKey,
        size: "invisible",
        badge: this.badge,
        callback: token => {
          this.submit(token);
          grecaptcha.reset(this.widgetId);
        }
      });
    },
    callRender: function() {
      const tout = setTimeout(() => {
        if (typeof grecaptcha !== "undefined" && grecaptcha.render) {
          this.render();
        } else {
          this.callRender();
        }
        clearTimeout(tout);
      }, 200);
    },
    execute: function() {
      const tout = setTimeout(() => {
        if (
          typeof grecaptcha !== "undefined" &&
          grecaptcha.execute &&
          (this.widgetId || this.widgetId === 0)
        ) {
          grecaptcha.execute(this.widgetId);
        } else {
          this.execute();
        }
        clearTimeout(tout);
      }, 200);
    }
  },
  watch: {
    executeSwitch: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.execute();
      }
    }
  }
};
</script>
